import { combineReducers } from 'redux';
import catalog from './catalog';
import statuses from './statuses';

export default combineReducers({
  entities: combineReducers({ catalog }),
  statuses,
});
